import "../App.css";
import "../functions/helper";
import "../style/main.scss";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/pro-solid-svg-icons";
import customFa from "../style/fontawesomeKit/fontawesomeIcons.json";
import { fal } from "@fortawesome/pro-light-svg-icons";
import { connect } from "react-redux";
import * as actionMain from "../reduxStore/actions/main.js";
import * as actionMap from "../reduxStore/actions/map.js";
import * as actionSettings from "../reduxStore/actions/settings.js";
import TapperController from "../components/elements/menu/tapperController";
import Map from "../components/mapUi/mapbox/map.component.jsx";
import EmitNetworkRequest from "../functions/classes/EmitNetworkRequest.class.js";
import * as actionRoute from "../reduxStore/actions/route.js";
import SaveZoneWrapper from "../components/elements/wrapper/saveZone.wrapper.jsx";
import * as actionInfo from "../reduxStore/actions/infoCard.js";
import { useLoadServerData } from "./app.sideEffects/useLoadServerData";
import routes from "./routes";
import RouteWithSubRoutes from "./RouteWithSubRoutes";
import { Switch } from "react-router-dom";
import {
  piKey,
  terminalDisplayDownPixels,
  terminalMainScreenBottomMargin,
  terminalStandardLanguage,
  useURLParams,
} from "./app.sideEffects/useURLParams.sideEffects";
import React, { useCallback, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import MainMenu from "../components/elements/menu/dragCard";
import SetURLParams from "../components/setURLParams/SetURLParams";
import { useCheckIntroAndCookiePiKey } from "./app.sideEffects/useCheckIntroAndCookiePiKey.sideEffects";
import useStyles from "./app.sideEffects/useStyles.sideEffects.js";
import * as actionDebug from "../reduxStore/actions/debug.js";

import Overlays from "../components/elements/Overlays/AppOverlays.component.jsx";
import {
  CAMPUS_COLLECTION,
  completeIntro,
  setCurrentAppOverlay,
  setCustomStyleId,
  setIsTerminal,
  setTerminalIsIdle,
} from "../reduxStore/actions/main.js";
import { setProperties } from "../reduxStore/actions/settings.js";
import { setDefaultStartNode } from "../reduxStore/actions/route.js";
import useUpload from "./app.sideEffects/useUpload.sideEffects.js";
import { addToast } from "../reduxStore/actions/toasts.js";
import useTerminalIdleMode from "./app.sideEffects/useTerminalTimeout.sideEffects.js";
import { setTerminalBearing } from "../reduxStore/actions/map.js";
import { hideNativeLoadingScreen } from "../components/nativeAppInterface/NativeAppInterface.jsx";
import useServiceWorker from "./app.sideEffects/useServiceWorker";
import StatisticLog from "../components/statisticLogger/StatisticLogger.container";
import useRedirect from "./app.sideEffects/useRedirect.sideEffects";
import useDualScreenResize from "./app.sideEffects/useDualScreenResize.sideEffects";
import DualScreen from "./DualScreen";
import { useSettings } from "./app.sideEffects/useSettings.sideEffects";
import { setFavouritesFromStorage } from "../reduxStore/actions/phonebook";
import { setSearchesFromStorage } from "../reduxStore/actions/search";
import { nativeStorageInterface } from "..";
import * as action from "../reduxStore/actions/floors";

// customFa sind die Custom FontAwesomeIcons die im StyleOrdner gespeichert sind
library.add({ ...fas, ...customFa }, fal);

export const networkRequests = new EmitNetworkRequest();

function App(props) {
  const [start, setStart] = useState(null);
  const [destination, setDestination] = useState(null);
  const [rasterImages, setRasterImages] = useState([]);

  useEffect(() => {
    const checkForUpdate = async () => {
      const res = await fetch(`${process.env.REACT_APP_GET_VERSION}`, {
        method: "POST",
        cache: "no-cache",
      });
      if (res.ok) {
        const content = await res.json();

        if (
          content.version !== "all" &&
          content.version !== process.env.REACT_APP_APP_VERSION_NAME
        ) {
          const registrations =
            await navigator.serviceWorker.getRegistrations();
          for await (let registration of registrations) {
            await registration.unregister();
          }

          //@ts-ignore
          //window.location.reload(true);
        }
      }
    };
    if (process.env.REACT_APP_IS_PROD === "true") {
      checkForUpdate().then(() => {});
    }
  }, []);

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    setStart(urlParams.get("start"));
    setDestination(urlParams.get("destination"));
  }, []);
  useServiceWorker(
    props.setServiceWorkerActive,
    props.isApp,
    props.serviceWorkerActive
  );
  useURLParams(props);
  useLoadServerData(props);
  useStyles(props);
  useSettings(
    props.setLanguage,
    props.setSettingsFromStorage,
    props.setFavouritesFromStorage,
    props.setSearchesFromStorage,
    props.serverDataLoaded,
    props.currentCampusId,
    props.setSettingsSet
  );
  useCheckIntroAndCookiePiKey(props);
  useUpload(props.uploadItem, props.addToast);
  useTerminalIdleMode(
    props.isTerminal,
    props.terminalIsIdle,
    props.setTerminalIsIdle,
    props.history,
    props.introComplete,
    props.setCurrentAppOverlay,
    props.setCurrentFeature,
    props.setLanguage
  );

  useEffect(() => {
    if (props.isTerminal) {
      props.setLanguage(terminalStandardLanguage);
    }
  }, [props.isTerminal]);

  useRedirect(props);
  const dualScreenSizes = useDualScreenResize();

  useEffect(() => {
    nativeStorageInterface.set(
      "WebAppVersion",
      process.env.REACT_APP_APP_VERSION_NAME
    );
    setTimeout(() => {
      hideNativeLoadingScreen();
    }, 2000);
  }, []);

  useEffect(() => {
    //Perfekt! man bekommt keinen Campuswechsel mit. Lieben wir!
    const loadRasterImages = async () => {
      const variables = {
        campusKey: CAMPUS_COLLECTION?.getCurrentCampus().campusKey,
        appId: "NaviApp",
      };
      const query = `query GetRasterImages($campusKey:String!, $appId:String!) {
  rasterImages(campusKey:$campusKey, appId:$appId) {
    id
    url
    corners
    level
    opacity
    beforeId
  }
}
`;
      const body = JSON.stringify({
        query,
        variables,
        operationName: "GetRasterImages",
      });
      const res = await fetch(process.env.REACT_APP_RASTER_IMAGE_API, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body,
      });
      const data = await res.json();
      setRasterImages(data.data.rasterImages);
    };
    if (CAMPUS_COLLECTION?.getCurrentCampus()) loadRasterImages().then();
  }, [props.serverDataLoaded]);

  // Das hier wird verwendet, damit übergeordnete Applikationen, die die NaviApp einbinden, über Aktivität benachrichtigt werden können.
  const notifyClickIframeCb = useCallback(() => {
    // eslint-disable-next-line no-restricted-globals
    parent.postMessage("catchup-on-click", "*");
  }, []);

  useEffect(() => {
    document.addEventListener("click", notifyClickIframeCb);
    return () => {
      document.removeEventListener("click", notifyClickIframeCb);
    };
  }, []);

  return (
    <div className="App">
      {dualScreenSizes.width !== 0 && (
        <DualScreen
          width={dualScreenSizes.width}
          marginTop={dualScreenSizes.marginTop}
          marginBottom={dualScreenSizes.marginBottom}
        />
      )}
      <div
        className="main"
        style={{ marginBottom: terminalMainScreenBottomMargin }}
      >
        {props.introComplete && (
          <Map
            rasterImages={rasterImages}
            start={start}
            startLevel={props.startLevel}
            destination={destination}
          />
        )}

        <SaveZoneWrapper
          style={
            props.displayDownMode
              ? {
                  paddingTop: terminalDisplayDownPixels,
                  transition: "1s",
                }
              : {
                  transition: "1s",
                }
          }
        >
          <div className="d-flex flex-column h-100 w-100 general-padding-vertically">
            <Switch>
              {routes.map((route, i) => {
                return <RouteWithSubRoutes key={i} {...route} />;
              })}
              {/* <Redirect
              to={`/${pageNames.map}/${pageNames.info}${window.location.search}`}
            /> */}
            </Switch>
            {props.mainMenuStatus !== "close" ? (
              <MainMenu piKey={piKey} />
            ) : null}
            {props.serverDataLoaded && showFooterMenu(props) ? (
              <TapperController piKey={piKey} />
            ) : null}
          </div>
        </SaveZoneWrapper>
        <Overlays />
      </div>
      <StatisticLog />
      <SetURLParams piKey={piKey} />
    </div>
  );
}

// Redux zum holen der States
const mapStateToProps = (state) => {
  return {
    piKeyState: state.main.piKeyState,
    showCreateAppointment: state.appointment.showCreateAppointment,
    userAllowedGPS: state.settings.location.userAllowed,
    campusKeys: state.main.campusKeys,
    urlCampusKeys: state.main.urlCampusKeys,
    serverDataLoaded: state.main.serverDataLoaded,
    designDataLoaded: state.main.designDataLoaded,
    currentPage: state.main.currentPage,
    currentMapPage: state.map.currentPage,
    currentBoundBuildingId: state.map.currentBoundBuildingId,
    isApp: state.main.isApp,
    isTerminal: state.main.isTerminal,
    terminalIsIdle: state.main.terminalIsIdle,
    content: state.main.content,
    mapLoaded: state.map.mapLoaded,
    mainMenuStatus: state.mainMenu.status,
    introComplete: state.main.introComplete,
    sessionId: state.main.sessionId,
    customer: state.main.customer,
    language: state.main.language,
    // todo: das muss raus, weil updated die ganze app viel viel zu oft! aber wird noch verwendet!
    locationObject: state.route.locationObject,
    settings: state.settings,
    currentCampusId: state.main.currentCampusId,
    currentCampusKey: state.main.currentCampusKey,
    availableCampuses: state.main.availableCampuses,
    newAvailableCampuses: state.main.newAvailableCampuses,
    uploadItem: state.debug.uploadItem,
    customStyleId: state.main.customStyleId,
    lastCampusId: state.settings.campus.lastCampusId,
    serviceWorkerActive: state.main.serviceWorkerActive,
    displayDownMode: state.main.displayDownMode,
    urlParametersReady: state.main.urlParametersReady,
    cookieSettingsReceived: state.settings.cookieSettingsReceived,
    storageSettingsSet: state.main.storageSettingsSet,
    currentFeature: state.main.currentFeature,
    startLevel: state.route.start,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setCurrentFloor: (number) => dispatch(action.setCurrentFloorIndex(number)),
    setTerminalIsIdle: (value) => dispatch(setTerminalIsIdle(value)),
    setMapboxServerdata: (payload) =>
      dispatch(actionMap.setMapboxServerdata(payload)),
    setDesignDataLoaded: (value) =>
      dispatch(actionMain.setDesignDataLoaded(value)),
    setCurrentAppOverlay: (value) => dispatch(setCurrentAppOverlay(value)),
    setMapboxStates: (payload) => dispatch(actionMap.setMapboxStates(payload)),
    setGEOJSONS: (payload) => dispatch(actionMain.setGEOJSONS(payload)),
    setIsApp: (isApp) => dispatch(actionMain.setIsApp(isApp)),
    setHasSeparateSearchScreen: (value) =>
      dispatch(actionMain.setHasSeparateSearchScreen(value)),
    setUploadData: (shoutUploadData) =>
      dispatch(actionMain.setUploadData(shoutUploadData)),
    setSettingsFromStorage: (savedSettings) =>
      dispatch(actionSettings.setSettingsFromStorage(savedSettings)),
    createSessionId: () => dispatch(actionMain.generateSessionId()),
    setStart: (gpsObject) => dispatch(actionRoute.setStart(gpsObject)),
    setTarget: (gpsObject) => dispatch(actionRoute.setTarget(gpsObject)),
    setCurrentFeature: (feature) =>
      dispatch(actionMain.setCurrentFeature(feature)),
    setPreOpen: () => dispatch(actionInfo.setPreOpen()),
    setFetchNewRoute: (status) =>
      dispatch(actionRoute.setFetchNewRoute(status)),
    setPage: (page) => dispatch(actionMap.setPage(page)),
    setCustomerInformation: (customer) =>
      dispatch(actionMain.setCustomerInformation(customer)),
    setSaveZonePadding: ({ top, bottom }) =>
      dispatch(actionSettings.setSaveZonePadding({ top, bottom })),
    setProperties: (propertyObject) =>
      dispatch(actionSettings.setProperties(propertyObject)),
    setTerminalBearing: (bearing) => dispatch(setTerminalBearing(bearing)),
    setAvailableCampus: (piKey) =>
      dispatch(actionMain.setAvailableCampuses(piKey)),
    loadCampuses: (campusKeys, locale, userGroup) =>
      dispatch(actionMain.loadCampuses(campusKeys, locale, userGroup)),
    setCampusKeys: (campusKeys) =>
      dispatch(actionMain.setCampusKeys(campusKeys)),
    setURLCampusKeys: (campusKey) =>
      dispatch(actionMain.setURLCampusKeys(campusKey)),
    setUserAllowedGPS: (userAllowedGPS) =>
      dispatch(setProperties({ location: { userAllowed: userAllowedGPS } })),
    setCurrentCampusId: (id) => dispatch(actionMain.setCurrentCampusId(id)),
    setCurrentCampusKey: (campusKey) =>
      dispatch(actionMain.setCurrentCampusKey(campusKey)),

    setDebuggingValues: (values) =>
      dispatch(actionDebug.setDebuggingValues(values)),
    getSessionKey: () => dispatch(actionMain.getSessionKey()),
    setDefaultStartNode: (nodeId) => dispatch(setDefaultStartNode(nodeId)),
    addToast: (toastObject) => dispatch(addToast(toastObject)),
    completeIntro: () => dispatch(completeIntro()),
    setIsTerminal: () => dispatch(setIsTerminal()),
    setCustomStyleId: (id) => dispatch(setCustomStyleId(id)),
    setServiceWorkerActive: (value) =>
      dispatch(actionMain.setServiceWorkerActive(value)),
    setPiKeyState: (piKey) => dispatch(actionMain.setPiKeyState(piKey)),
    setURLParametersReady: (value) =>
      dispatch(actionMain.setURLParametersReady(value)),
    setLanguage: (value) => dispatch(actionMain.setLanguage(value)),
    setFavouritesFromStorage: (favorites) =>
      dispatch(setFavouritesFromStorage(favorites)),
    setSearchesFromStorage: (lastSearch) =>
      dispatch(setSearchesFromStorage(lastSearch)),
    setSettingsSet: (value) => dispatch(actionSettings.setSettingsSet(value)),
  };
};

function showFooterMenu(props) {
  let params = new URL(document.location).searchParams;

  let hideTabbar = params.get("hideTabbar");

  if (hideTabbar && hideTabbar.toLowerCase() === "true") return false;

  return !(
    props.location.pathname.includes("/intro/") ||
    props.location.pathname.includes("/route/") ||
    props.location.pathname.includes("/search/") ||
    props.location.pathname.includes("/settings/") ||
    props.location.pathname.includes("/navigation/")
  );
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
